import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { GreenChargingIcon } from '../icons/green-charging-icon'
import Text from '../../ui/Text'
import { InfoIcon } from '../icons/info-icon'
import { theme } from '../theme'
import { Button } from '../../common/components/Button'
import useText from '../../common/hooks/useText'

const SContainer = styled.div`
    border: 1px solid transparent;
    border-radius: 4px;
    color: black;
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    margin-bottom: ${({ theme }) => theme.sizing.padding.l};
    padding: ${({ theme }) => theme.sizing.padding.s};
    overflow: hidden;
    background-color: ${({ theme }) => theme.font.successColor + '2a'};
`

const SGreenChargingIconWrapper = styled.div`
    margin-right: ${({ theme }) => theme.sizing.margin.l};
    padding: ${({ theme }) => theme.sizing.padding.m};
    background-color: ${({ theme }) => theme.font.successColor};
    svg {
        position: relative;
        top: -1px;
    }
`

const SInfoIconWrapper = styled.div`
    padding: 0 14px;
`

const SInfoContainer = styled.div`
    display: flex;
    align-items: center;
`

export type GreenChargingBadgeProps = {
    isTurnOffRequestLoading?: boolean
    turnOffDisabled?: boolean
    onTurnOff?: () => void
    infoIconTooltip?: string
    className?: ClassName
    style?: React.CSSProperties
}

export function GreenChargingBadge(props: GreenChargingBadgeProps): React.ReactElement {
    const text = useText()
    const {
        onTurnOff,
        turnOffDisabled,
        className,
        style,
        infoIconTooltip = text('msgScheduleDisabledWhileGreenCharging'),
        isTurnOffRequestLoading,
    } = props
    return (
        <SContainer className={cn(className)} style={style}>
            <SInfoContainer>
                <SGreenChargingIconWrapper>
                    <GreenChargingIcon size={18} />
                </SGreenChargingIconWrapper>
                <Text code="msgChargerIsInGreenChargingMode" />
                <SInfoIconWrapper data-testid="info-icon" title={infoIconTooltip}>
                    <InfoIcon fill={theme.brandColors.CA_Blue} size={19} />
                </SInfoIconWrapper>
            </SInfoContainer>
            {onTurnOff && (
                <Button
                    size="xs"
                    label={text('btnOff')}
                    onClick={onTurnOff}
                    disabled={turnOffDisabled}
                    loading={isTurnOffRequestLoading}
                />
            )}
        </SContainer>
    )
}
